var path = '/app/components/header/live-support.component.html';
var html = "<div id=\"aa-header-live-support\" title=\"{{ 'liveSupportToolTip' | translate }}\"> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;